<template>
  <el-tooltip
    effect="dark"
    :content="content"
    placement="top-end"
    :disabled="isShowTooltip"
    v-bind="$attrs"
    :open-delay="200"
  >
    <div class="text-wrap" @mouseover="onMouseOver">
      <slot></slot>
      <span ref="text" v-show="!$slots.default">{{ text }}</span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'text-tooltip',
  props: ['text', 'notip'],
  data () {
    return {
      content: '',
      isShowTooltip: false,
      // 元素计算后的宽度
      computedWidth: 0
    }
  },
  methods: {
    onMouseOver (str) {
      // 内容超出，显示文字提示内容
      const tag =
        (this.$slots.default && this.$slots.default[0].elm) || this.$refs.text
      const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
      // 获取元素可视宽度  获取不到则去缓存获取 没有缓存自己会进行计算  但目前仅仅只支持text节点
      const contentWidth = tag.offsetWidth || this.computedWidth

      // // 当未获取到内容宽度时 置disabled为true
      // if (contentWidth === undefined) {
      //   return (this.isShowTooltip = true)
      // }

      this.isShowTooltip = contentWidth < parentWidth
      // offset获取宽度获取不到
      if (!contentWidth) {
        // Text也就是文本节点

        if (tag.constructor === Text) {
          const range = document.createRange()
          range.setStart(tag.parentNode, 0)
          range.setEnd(tag.parentNode, tag.parentNode.childNodes.length)
          this.computedWidth = range.getBoundingClientRect().width

          // Tag为文本则展示tag的内容
          return (this.content = tag.data)
        }
      }
      this.content = this.text
    }
  }
}
</script>

<style scoped>
.text-wrap {
  width: 100%;
  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
